module.exports = __webpack_public_path__ + "static/media/testingActive.6aa67791.png";